// Author XXL
// Date 2020-10-27 10:11:55

import * as model from "@/model/sithMes/quality/SithMesQualityKpiPassRateModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityKpiPassRate(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
